// actions
export const LOAD_QUIZZES = 'LOAD_QUIZZES'
export const SYNC_QUIZZES = 'SYNC_QUIZZES'

export const NEXT_QUESTION = 'NEXT_QUESTION'
export const RESPONSE = 'RESPONSE'
export const GENERATE_RANDOM_QUIZ = 'GENERATE_RANDOM_QUIZ'

// commit
export const ADD_QUIZ = 'ADD_QUIZ'
export const REMOVE_QUIZ = 'REMOVE_QUIZ'
export const RESET_QUIZ_FIREBASE_ID = 'RESET_QUIZ_FIREBASE_ID'
export const SET_CURRENT_QUIZ = 'SET_CURRENT_QUIZ'
export const SET_COMING_FROM_PROGRESSION = 'SET_COMING_FROM_PROGRESSION'
export const SET_QUESTIONS = 'SET_QUESTIONS'
export const SET_QUIZ_FIREBASE_ID = 'SET_QUIZ_FIREBASE_ID'
export const SET_QUIZZES = 'SET_QUIZZES'
export const SET_RANDOM_QUIZ_QUESTIONS = 'SET_RANDOM_QUIZ_QUESTIONS'
export const SET_RESPONSE = 'SET_RESPONSE'
